import React, { useState, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import api from '../api/api'
import CheckoutForm from './CheckoutForm'

const Stripe = ({ price, orderNumber, notes, sellerId, sellerName, shippingInfo, currencySymbol = "$" }) => {
    const [clientSecret, setClientSecret] = useState('')
    const [stripePromise, setStripePromise] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchStripeConfig = async () => {
            try {
                // Use sellerId from props
                if (!sellerId) {
                    setError('Seller ID not found');
                    setLoading(false);
                    return;
                }

                // Fetch seller's enabled payment methods (includes Stripe config)
                const { data } = await api.get(`/seller/${sellerId}/payment-methods`);
                if (data.success && data.config.stripe && data.config.stripe.isEnabled) {
                    // Check if publishableKey exists and is valid
                    if (!data.config.stripe.publishableKey || data.config.stripe.publishableKey.trim() === '') {
                        setError('Stripe publishable key is not configured for this seller');
                        setLoading(false);
                        return;
                    }
                    
                    const stripe = loadStripe(data.config.stripe.publishableKey);
                    setStripePromise(stripe);
                } else {
                    setError('Stripe is not enabled or configured for this seller');
                }
            } catch (error) {
                console.error('Error fetching Stripe config:', error);
                setError('Failed to load Stripe configuration');
            } finally {
                setLoading(false);
            }
        }

        fetchStripeConfig();
    }, [sellerId])

    const apperance = {
        theme: 'stripe'
    }
    
    const options = {
        apperance,
        clientSecret
    }

    const create_payment = async () => {
        try {
            setError(null); // Clear any previous errors
            const { data } = await api.post('/order/create-payment', { 
                price,
                sellerId,
                shippingInfo // Include shipping info for guest checkout
            })
            
            if (data && data.clientSecret) {
                setClientSecret(data.clientSecret)
            } else {
                throw new Error('No client secret received from server');
            }
        } catch (error) {
            console.error('Error creating payment:', error)
            setError(error.response?.data?.message || 'Failed to create payment')
        }
    }

    if (loading) {
        return <div className="mt-4 text-center">Loading Stripe...</div>
    }

    if (error) {
        return <div className="mt-4 text-red-500 text-center">{error}</div>
    }

    if (!stripePromise) {
        return <div className="mt-4 text-red-500 text-center">Stripe is not configured for this seller</div>
    }

    return (
        <div className='mt-4'>
            {
                clientSecret ? (
                    <div>
                        {stripePromise && (
                            <Elements options={options} stripe={stripePromise}>
                                <CheckoutForm orderNumber={orderNumber} notes={notes} />
                            </Elements>
                        )}
                    </div>
                ) : (
                    <button 
                        onClick={create_payment} 
                        disabled={!stripePromise}
                        className={`px-10 py-[6px] rounded-sm hover:shadow-orange-500/20 hover:shadow-lg ${
                            stripePromise 
                                ? 'bg-orange-500 text-white hover:bg-orange-600' 
                                : 'bg-gray-400 text-gray-200 cursor-not-allowed'
                        }`}
                    >
                        Start Payment
                    </button>
                )
            }
        </div>
    )
}

export default Stripe